export const TOKEN_INFO = {
  2: { likelihood: 1 },
  3: { likelihood: 2 },
  4: { likelihood: 3 },
  5: { likelihood: 4 },
  6: { likelihood: 5 },
  7: { likelihood: 6 },
  8: { likelihood: 5 },
  9: { likelihood: 4 },
  10: { likelihood: 3 },
  11: { likelihood: 2 },
  12: { likelihood: 1 },
} as const;

export const RESOURCE_TYPES = {
  lumber: { bg: '#050', fg: '#fff' },
  grain: { bg: '#cb3', fg: '#000' },
  ore: { bg: '#555', fg: '#fff' },
  wool: { bg: '#7d7', fg: '#000' },
  brick: { bg: '#600', fg: '#fff' },
  desert: { bg: '#fec', fg: '#000' },
} as const;

export const RESOURCES: SizeOptions<ResourceName> = {
  jumbo: [
    'lumber',
    'lumber',
    'lumber',
    'lumber',
    'lumber',
    'lumber',
    'grain',
    'grain',
    'grain',
    'grain',
    'grain',
    'grain',
    'wool',
    'wool',
    'wool',
    'wool',
    'wool',
    'wool',
    'ore',
    'ore',
    'ore',
    'ore',
    'ore',
    'brick',
    'brick',
    'brick',
    'brick',
    'brick',
    'desert',
    'desert',
  ],
  normal: [
    'lumber',
    'lumber',
    'lumber',
    'lumber',
    'grain',
    'grain',
    'grain',
    'grain',
    'wool',
    'wool',
    'wool',
    'wool',
    'ore',
    'ore',
    'ore',
    'brick',
    'brick',
    'brick',
    'desert',
  ],
};

export const HEX_COUNT_PER_RESOURCE = {
  jumbo: countHexesPerResource(RESOURCES.jumbo),
  normal: countHexesPerResource(RESOURCES.normal),
} as const;

export const POSITIONS: SizeOptions<PositionInfo> = {
  jumbo: [
    { x: 0, y: 0, adjacent: [1,2,3,4,5,6], interiority: 'central' }, // 0
    { x: 1, y: 1, adjacent: [0,2,9,8,7,6], interiority: 'central' }, // 1
    { x: 1, y: -1, adjacent: [1,0,3,11,10,9], interiority: 'central' }, // 2
    { x: 0, y: -2, adjacent: [13,12,11,2,0,4], interiority: 'central' }, // 3
    { x: -1, y: -1, adjacent: [3,0,5,15,14,13], interiority: 'outer' }, // 4
    { x: -1, y: 1, adjacent: [4,0,6,17,16,15], interiority: 'outer' }, // 5
    { x: 0, y: 2, adjacent: [5,0,1,7,18,17], interiority: 'outer' }, // 6
    { x: 1, y: 3, adjacent: [6,1,8,20,19,18], interiority: 'outer' }, // 7
    { x: 2, y: 2, adjacent: [7,1,9,22,21,20], interiority: 'outer' }, // 8
    { x: 2, y: 0, adjacent: [8,1,2,10,23,22], interiority: 'outer' }, // 9
    { x: 2, y: -2, adjacent: [9,2,11,25,24,23], interiority: 'outer' }, // 10
    { x: 1, y: -3, adjacent: [10,2,3,12,26,25], interiority: 'outer' }, // 11
    { x: 0, y: -4, adjacent: [11,3,13,28,27,26], interiority: 'outer' }, // 12
    { x: -1, y: -3, adjacent: [12,3,4,14,29,28], interiority: 'outer' }, // 13
    { x: -2, y: -2, adjacent: [29,13,4,15], interiority: 'coastal' }, // 14
    { x: -2, y: 0, adjacent: [14,4,5,16], interiority: 'coastal' }, // 15
    { x: -2, y: 2, adjacent: [15,5,17], interiority: 'coastal' }, // 16
    { x: -1, y: 3, adjacent: [16,5,6,18], interiority: 'coastal' }, // 17
    { x: 0, y: 4, adjacent: [17,6,7,19], interiority: 'coastal' }, // 18
    { x: 1, y: 5, adjacent: [18,7,20], interiority: 'coastal' }, // 19
    { x: 2, y: 4, adjacent: [19,7,8,21], interiority: 'coastal' }, // 20
    { x: 3, y: 3, adjacent: [20,8,22], interiority: 'coastal' }, // 21
    { x: 3, y: 1, adjacent: [21,8,9,23], interiority: 'coastal' }, // 22
    { x: 3, y: -1, adjacent: [22,9,10,24], interiority: 'coastal' }, // 23
    { x: 3, y: -3, adjacent: [23, 10, 25], interiority: 'coastal' }, // 24
    { x: 2, y: -4, adjacent: [24,10,11,26], interiority: 'coastal' }, // 25
    { x: 1, y: -5, adjacent: [25,11,12,27], interiority: 'coastal' }, // 26
    { x: 0, y: -6, adjacent: [26,12,28], interiority: 'coastal' }, // 27
    { x: -1, y: -5, adjacent: [27,12,13,29], interiority: 'coastal' }, // 28
    { x: -2, y: -4, adjacent: [28,13,14], interiority: 'coastal' }, // 29
  ],
  normal: [
    { x: 0, y: 0, adjacent: [6, 5, 4, 3, 2, 1], interiority: 'central' }, // 0
    { x: 1, y: 1, adjacent: [0, 2, 9, 8, 7, 6], interiority: 'outer' }, // 1
    { x: 1, y: -1, adjacent: [11, 10, 9, 1, 0, 3], interiority: 'outer' }, // 2
    { x: 0, y: -2, adjacent: [2, 0, 4, 13, 12, 11], interiority: 'outer' }, // 3
    { x: -1, y: -1, adjacent: [15, 14, 13, 3, 0, 5], interiority: 'outer' }, // 4
    { x: -1, y: 1, adjacent: [4, 0, 6, 17, 16, 15], interiority: 'outer' }, // 5
    { x: 0, y: 2, adjacent: [5, 0, 1, 7, 17, 18], interiority: 'outer' }, // 6
    { x: 1, y: 3, adjacent: [18, 6, 1, 8], interiority: 'coastal' }, // 7
    { x: 2, y: 2, adjacent: [7, 1, 9], interiority: 'coastal' }, // 8
    { x: 2, y: 0, adjacent: [8, 1, 2, 10], interiority: 'coastal' }, // 9
    { x: 2, y: -2, adjacent: [9, 2, 11], interiority: 'coastal' }, // 10
    { x: 1, y: -3, adjacent: [10, 2, 3, 12], interiority: 'coastal' }, // 11
    { x: 0, y: -4, adjacent: [11, 3, 13], interiority: 'coastal' }, // 12
    { x: -1, y: -3, adjacent: [12, 3, 4, 14], interiority: 'coastal' }, // 13
    { x: -2, y: -2, adjacent: [13, 4, 15], interiority: 'coastal' }, // 14
    { x: -2, y: 0, adjacent: [14, 4, 5, 16], interiority: 'coastal' }, // 15
    { x: -2, y: 2, adjacent: [15, 5, 17], interiority: 'coastal' }, // 16
    { x: -1, y: 3, adjacent: [16, 5, 6, 18], interiority: 'coastal' }, // 17
    { x: 0, y: 4, adjacent: [17, 6, 7], interiority: 'coastal' }, // 18
  ],
};

export const TOKEN_ORDERINGS: SizeOptions<number[]> = {
  jumbo: [
    [27, 26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 29, 28, 12, 11, 10, 9, 8, 7, 6, 5, 4, 13, 3, 2, 1, 0],
    [24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 29, 28, 27, 26, 25, 10, 9, 8, 7, 6, 5, 4, 13, 12, 11, 2, 1, 0, 3],
    [21, 20, 19, 18, 17, 16, 15, 14, 29, 28, 27, 26, 25, 24, 23, 22, 8, 7, 6, 5, 4, 13, 12, 11, 10, 9, 1, 0, 3, 2],
    [19, 18, 17, 16, 15, 14, 29, 28, 27, 26, 25, 24, 23, 22, 21, 20, 7, 6, 5, 4, 13, 12, 11, 10, 9, 8, 1, 0, 3, 2],
    [16, 15, 14, 29, 28, 27, 26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 5, 4, 13, 12, 11, 10, 9, 8, 7, 6, 0, 3, 2, 1],
    [29, 28, 27, 26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
  ],
  normal: [
    [12, 11, 10, 9, 8, 7, 18, 17, 16, 15, 14, 13, 3, 2, 1, 6, 5, 4, 0],
    [10, 9, 8, 7, 18, 17, 16, 15, 14, 13, 12, 11, 2, 1, 6, 5, 4, 3, 0],
    [8, 7, 18, 17, 16, 15, 14, 13, 12, 11, 10, 9, 1, 6, 5, 4, 3, 2, 0],
    [18, 17, 16, 15, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
    [16, 15, 14, 13, 12, 11, 10, 9, 8, 7, 18, 17, 5, 4, 3, 2, 1, 6, 0],
    [14, 13, 12, 11, 10, 9, 8, 7, 18, 17, 16, 15, 4, 3, 2, 1, 6, 5, 0],
  ],
};

export const TOKENS: SizeOptions<RollValue> = {
  jumbo: [
    2,
    5,
    4,
    6,
    3,
    9,
    8,
    11,
    11,
    10,
    6,
    3,
    8,
    4,
    8,
    10,
    11,
    12,
    10,
    5,
    4,
    9,
    5,
    9,
    12,
    3,
    2,
    6,
  ],
  normal: [
    5,
    2,
    6,
    3,
    8,
    10,
    9,
    12,
    11,
    4,
    8,
    10,
    9,
    4,
    5,
    6,
    3,
    11,
  ],
};

for (let i=0; i<POSITIONS.normal.length; i++) {
  const jp = POSITIONS.normal[i];
  for (const adj of jp.adjacent) {
    const other = POSITIONS.normal[adj];
    if (!other.adjacent.includes(i)) {
      throw new Error(`${i} refs ${adj} but not vice versa`);
    }
  }
}

for (let i=0; i<POSITIONS.jumbo.length; i++) {
  const jp = POSITIONS.jumbo[i];
  for (const adj of jp.adjacent) {
    const other = POSITIONS.jumbo[adj];
    if (!other.adjacent.includes(i)) {
      throw new Error(`${i} refs ${adj} but not vice versa`);
    }
  }
}

export const REGIONS = ['central', 'outer', 'coastal'] as const;

export const DESERT_PLACEMENTS = [
  { name: 'Exact Center', value: 'central' },
  { name: 'Central/Outer', value: 'outer' },
  { name: 'Coastal', value: 'coastal' },
  { name: 'Anywhere', value: 'anywhere' },
] as const;

export const COLLISIONS = [
  { collisions: 0, label: 'Duplicates = 0' },
  { collisions: 1, label: 'Duplicates = 1' },
  { collisions: 2, label: 'Duplicates = 2' },
  { collisions: 3, label: 'Duplicates = 3' },
  { collisions: 4, label: 'Duplicates = 4' },
  { collisions: 5, label: 'Duplicates = 5' },
  { collisions: 6, label: 'Duplicates = 6' },
  { collisions: 7, label: 'Duplicates = 7' },
] as const;

export const ADJACENCIES = [
  { adjacencies: 0, label: 'Adjacencies = 0' },
  { adjacencies: 1, label: 'Adjacencies = 1' },
  { adjacencies: 2, label: 'Adjacencies = 2' },
  { adjacencies: 3, label: 'Adjacencies = 3' },
  { adjacencies: 4, label: 'Adjacencies = 4' },
  { adjacencies: 5, label: 'Adjacencies = 5' },
  { adjacencies: 6, label: 'Adjacencies = 6' },
  { adjacencies: 7, label: 'Adjacencies = 7' },
  { adjacencies: 8, label: 'Adjacencies = 8' },
  { adjacencies: 9, label: 'Adjacencies = 9' },
  { adjacencies: 10, label: 'Adjacencies = 10' },
  { adjacencies: 11, label: 'Adjacencies = 11' },
  { adjacencies: 12, label: 'Adjacencies = 12' },
  { adjacencies: 13, label: 'Adjacencies = 13' },
  { adjacencies: 14, label: 'Adjacencies = 14' },
  { adjacencies: 15, label: 'Adjacencies = 15' },
  { adjacencies: 16, label: 'Adjacencies = 16' },
  { adjacencies: 17, label: 'Adjacencies = 17' },
  { adjacencies: 18, label: 'Adjacencies = 18' },
  { adjacencies: 19, label: 'Adjacencies = 19' },
  { adjacencies: 20, label: 'Adjacencies = 20' },
  { adjacencies: 21, label: 'Adjacencies = 21' },
  { adjacencies: 22, label: 'Adjacencies = 22' },
] as const;

export const MIN_IMBALANCE = {
  normal: 0.33,
  jumbo: 0.2,
} as const;

export const IMBALANCES = [
  { imbalance: 0.0, label: 'Imbalance ≈ 0.0' },
  { imbalance: 0.25, label: 'Imbalance ≈ 0.25' },
  { imbalance: 0.5, label: 'Imbalance ≈ 0.5' },
  { imbalance: 0.75, label: 'Imbalance ≈ 0.75' },
  { imbalance: 1.0, label: 'Imbalance ≈ 1.0' },
  { imbalance: 1.25, label: 'Imbalance ≈ 1.25' },
  { imbalance: 1.5, label: 'Imbalance ≈ 1.5' },
  { imbalance: 1.75, label: 'Imbalance ≈ 1.75' },
  { imbalance: 2.0, label: 'Imbalance ≈ 2.0' },
  { imbalance: 2.25, label: 'Imbalance ≈ 2.25' },
  { imbalance: 2.5, label: 'Imbalance ≈ 2.5' },
  { imbalance: 2.75, label: 'Imbalance ≈ 2.75' },
  { imbalance: 3.0, label: 'Imbalance ≈ 3.0' },
] as const;

export const PORTS: SizeOptions<Port> = {
  normal: [
    { xIncrs: -1/3, yIncrs: 5, ratio: '3:1', type: '?', angle: 120 },
    { xIncrs: 1/3, yIncrs: 5, ratio: '3:1', type: '?', angle: 60 },
    { xIncrs: 4/3, yIncrs: 4, ratio: '2:1', type: 'ore', angle: 60 },
    { xIncrs: 5/3, yIncrs: 3, ratio: '2:1', type: 'ore', angle: 60 },
    { xIncrs: 7/3, yIncrs: 1, ratio: '2:1', type: 'grain', angle: 0 },
    { xIncrs: 8/3, yIncrs: 0, ratio: '2:1', type: 'grain', angle: 0 },
    { xIncrs: 8/3, yIncrs: -2, ratio: '3:1', type: '?', angle: 0 },
    { xIncrs: 7/3, yIncrs: -3, ratio: '3:1', type: '?', angle: 300 },
    { xIncrs: 4/3, yIncrs: -4, ratio: '2:1', type: 'lumber', angle: 300 },
    { xIncrs: 2/3, yIncrs: -4, ratio: '2:1', type: 'lumber', angle: 300 },
    { xIncrs: -2/3, yIncrs: -4, ratio: '2:1', type: 'brick', angle: 240 },
    { xIncrs: -4/3, yIncrs: -4, ratio: '2:1', type: 'brick', angle: 240 },
    { xIncrs: -7/3, yIncrs: -3, ratio: '3:1', type: '?', angle: 240 },
    { xIncrs: -8/3, yIncrs: -2, ratio: '3:1', type: '?', angle: 180 },
    { xIncrs: -8/3, yIncrs: 0, ratio: '3:1', type: '?', angle: 180 },
    { xIncrs: -7/3, yIncrs: 1, ratio: '3:1', type: '?', angle: 180 },
    { xIncrs: -5/3, yIncrs: 3, ratio: '2:1', type: 'wool', angle: 120 },
    { xIncrs: -4/3, yIncrs: 4, ratio: '2:1', type: 'wool', angle: 120 },
  ],
  jumbo: [
    { xIncrs: 2/3, yIncrs: 6, ratio: '3:1', type: '?', angle: 120 },
    { xIncrs: 4/3, yIncrs: 6, ratio: '3:1', type: '?', angle: 60 },
    { xIncrs: 7/3, yIncrs: 5, ratio: '2:1', type: 'lumber', angle: 60 },
    { xIncrs: 8/3, yIncrs: 4, ratio: '2:1', type: 'lumber', angle: 60 },
    { xIncrs: 11/3, yIncrs: 3, ratio: '3:1', type: '?', angle: 0 },
    { xIncrs: 10/3, yIncrs: 2, ratio: '3:1', type: '?', angle: 0 },
    { xIncrs: 10/3, yIncrs: 0, ratio: '2:1', type: 'brick', angle: 0 },
    { xIncrs: 11/3, yIncrs: -1, ratio: '2:1', type: 'brick', angle: 0 },
    { xIncrs: 11/3, yIncrs: -3, ratio: '3:1', type: '?', angle: 0 },
    { xIncrs: 10/3, yIncrs: -4, ratio: '3:1', type: '?', angle: 300 },
    { xIncrs: 4/3, yIncrs: -6, ratio: '3:1', type: '?', angle: 300 },
    { xIncrs: 2/3, yIncrs: -6, ratio: '3:1', type: '?', angle: 300 },
    { xIncrs: -2/3, yIncrs: -6, ratio: '2:1', type: 'wool', angle: 240 },
    { xIncrs: -4/3, yIncrs: -6, ratio: '2:1', type: 'wool', angle: 240 },
    { xIncrs: -7/3, yIncrs: -5, ratio: '3:1', type: '?', angle: 240 },
    { xIncrs: -8/3, yIncrs: -4, ratio: '3:1', type: '?', angle: 180 },
    { xIncrs: -8/3, yIncrs: 0, ratio: '2:1', type: 'ore', angle: 180 },
    { xIncrs: -7/3, yIncrs: 1, ratio: '2:1', type: 'ore', angle: 180 },
    { xIncrs: -5/3, yIncrs: 3, ratio: '2:1', type: 'wool', angle: 120 },
    { xIncrs: -4/3, yIncrs: 4, ratio: '2:1', type: 'wool', angle: 120 },
    { xIncrs: -2/3, yIncrs: 4, ratio: '2:1', type: 'grain', angle: 120 },
    { xIncrs: -1/3, yIncrs: 5, ratio: '2:1', type: 'grain', angle: 120 },
  ],
};

// -----------------------------------------

export interface Port {
  xIncrs: number;
  yIncrs: number;
  ratio: '3:1' | '2:1';
  type: ResourceName | '?';
  angle: number;
}

export type RollValue = keyof typeof TOKEN_INFO;

export type Interiority = typeof REGIONS[number];

export type DesertPlacement = typeof DESERT_PLACEMENTS[number]['value'];

interface PositionInfo {
  x: number;
  y: number;
  adjacent: number[];
  interiority: Interiority;
}

export type ResourceName = keyof typeof RESOURCE_TYPES;

export type GameVariant = keyof SizeOptions<any>;

export interface SizeOptions<T> {
  readonly jumbo: T[];
  readonly normal: T[];
}

export interface HexState {
  resource: ResourceName;
  rollValue: RollValue;
  position: number;
}

export interface GameSearchOptions {
  variant: GameVariant;
  imbalance: [number, number];
  adjacencies: [number, number];
  collisions: [number, number];
  desertPlacement: DesertPlacement;
}

interface UnstartedGameSearch extends GameSearchOptions {
  is: 'unstarted';
}

interface PausedGameSearch extends GameSearchOptions {
  generations: number;
  imperfectHexes: HexState[];
  is: 'paused';
}

interface InProgressGameSearch extends GameSearchOptions {
  is: 'in-progress';
  generations: number;
}

export interface DoneGameSearch extends GameSearchOptions {
  hexes: HexState[];
  generations: number;
  is: 'done';
}

export type GameSearch
  = UnstartedGameSearch
  | PausedGameSearch
  | InProgressGameSearch
  | DoneGameSearch;

function countHexesPerResource(resources: ResourceName[]): { [key in ResourceName]: number } {
  return {
    lumber: resources.filter(r => r === 'lumber').length,
    grain: resources.filter(r => r === 'grain').length,
    wool: resources.filter(r => r === 'wool').length,
    ore: resources.filter(r => r === 'ore').length,
    brick: resources.filter(r => r === 'brick').length,
    desert: resources.filter(r => r === 'desert').length,
  };
}
